// ABOUTME: Search-table cell renderer for a node's assigned owner/dealership/client/market reference.
// ABOUTME: Shows "code - listName" for the resolved AssignedNodeRef, or nothing when unassigned.

import { Typography } from '@ds/coolshop';
import type { DataTableRow } from '@ds/data-table';
import type { Row } from '@tanstack/react-table';

import { AssignedRefField, AssignedRefs, resolveAssignedRef } from '../assignedRefs';

export function GridCellAssignedRefRender({
    row,
    field,
    index,
}: {
    row: Row<DataTableRow>;
    field: AssignedRefField;
    /** the references of the current page by node id: the data-table row does not carry them */
    index?: Map<string, AssignedRefs>;
}) {
    const ref = resolveAssignedRef(row.original as Record<string, unknown>, field, index);

    if (!ref) {
        return null;
    }

    const label = ref.listName ? `${ref.code} - ${ref.listName}` : ref.code;

    return (
        <Typography variant="body2" overflow="hidden" textOverflow="ellipsis">
            {label}
        </Typography>
    );
}
